module.exports = __webpack_public_path__ + "static/media/appleIcon.b83a087a.svg";